var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortv2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#1d9bf0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1417 2489 c-91 -13 -182 -63 -257 -138 -104 -105 -150 -214 -150 -356 0 -139 40 -234 144 -343 221 -231 586 -188 766 90 55 83 74 165 68 286 -4 87 -9 107 -41 174 -101 211 -306 321 -530 287z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1234 c-174 -22 -421 -94 -566 -165 -102 -50 -198 -134 -234 -206 -22 -44 -25 -62 -28 -205 l-4 -158 1002 0 1002 0 -4 158 c-4 189 -15 219 -112 310 -76 70 -183 126 -351 181 -197 64 -306 83 -500 86 -93 2 -186 1 -205 -1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortv2);
export default __webpack_public_path__ + "static/media/portv2.c61375329489152d133d505ba155dcb1.svg";
export { ForwardRef as ReactComponent };